<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <section v-else-if="!userIsEmpty('user')" class="puzzles">
        <div class="block-header block-header-dark">
            <div class="container-mobile">
                <ul class="tabs tabs-dark">
                    <router-link tag="li" :to="{ name: 'my-puzzles' }" class="tabs-item"><a class="link-inherit">
                            {{ $t("puzzles.myPuzzles") }}
                        </a></router-link>
                    <div class="tabs-item tabs-current">{{ $t("puzzles.myPurchases") }}</div>
                </ul>
                <!--                <div class="puzzles-balance">-->
                <!--                    <div class="property">Счет:</div>-->
                <!--                    <div class="value">{{ user.account_balance }} ₽</div>-->
                <!--                    <button-->
                <!--                        @click="$modal.show('balance-out')"-->
                <!--                        class="button-yellow"-->
                <!--                    >Вывод <span class="puzzles-no-mobile">средств</span></button>-->
                <!--                </div>-->
            </div>
        </div>
        <div class="puzzles-info-block container-mobile">
            <div v-if="!puzzlesIsEmpty('puzzles')">
                <div class="puzzles-actions">
                    <div class="puzzles-sort">
                        <span>{{ $t("puzzles.sort") }}</span>
                        <span class="puzzles-sort-link">
                            <span @click="showSort = !showSort" ref="contextButton" class="link-blue-underlined">{{
                                sortArr[currentSort].text }}</span>
                            <ul v-if="showSort" v-click-outside="{
                                exclude: ['contextButton'],
                                handler: 'clickOutsideContext',
                            }" class="puzzles-sort-dropdown context">
                                <li v-for="item in sortArr" @click="sort(item.id)" :key="item.id"
                                    class="puzzles-sort-item context-item">
                                    {{ item.text }}
                                </li>
                            </ul>
                        </span>
                    </div>
                    <div class="puzzles-hide-complete checkbox-group">
                        <input v-model="hideComplete" @change="getPuzzles" type="checkbox" id="puzzles-hide-complete"
                            class="input-checkbox" />
                        <label for="puzzles-hide-complete" class="checkbox-label-relay">{{ $t("puzzles.hideCollected")
                        }}</label>
                    </div>
                </div>
                <div class="puzzles-list">
                    <div v-for="(puzzle, index) in puzzles" :ref="'element' + index" :key="puzzle.id" class="puzzles-item">
                        <PuzzlesItem :puzzle="puzzle" :index="index" @set-progress="setProgress"></PuzzlesItem>
                    </div>
                </div>
                <div class="puzzles-bottom">
                    <div v-if="moreLoader">
                        <button class="button-loader"></button>
                    </div>
                    <div class="puzzles-count">
                        {{ count }}
                        {{ declineNouns(count,
                            [$t("puzzles.puzzle"), $t("puzzles.puzzlE"), $t("puzzles.puzzles")]) }}
                    </div>
                </div>
            </div>
            <div v-else class="text">
                {{ $t("puzzles.youHavenAddedAnyPuzzlesYet") }}
            </div>
        </div>
    </section>
    <section v-else class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }">
            {{ $t("auth.noAuthLink") }}
        </router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { observeListEnd } from "@/mixins/observeListEnd";
import PuzzlesItem from "@/components/Blocks/PuzzlesItem";

export default {
    name: "Puzzles",
    props: {
        i18n: Object,
    },
    mixins: [declineNouns, observeListEnd],
    components: {
        PuzzlesItem,
    },
    data() {
        return {
            pageLoader: true,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
            SVG_NS: "http://www.w3.org/2000/svg",
            currentSort: 0,
            sortArr: [
                { id: 0, text: this.$t("puzzles.progress"), key: "progress" },
                { id: 1, text: this.$t("puzzles.dateAddition"), key: "date" },
            ],
            showSort: false,
            hideComplete: false,
            reverse: 1,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            puzzles: "puzzles/fetchPuzzles",
            puzzlesIsEmpty: "puzzles/isEmpty",
            next: "puzzles/fetchPuzzlesNext",
            count: "puzzles/fetchPuzzlesCount",
            puzzleUpdated: "puzzles/fetchPuzzleUpdated",
        }),
    },
    created() {
        this.getPuzzles();
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting === true) {
                    this.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    watch: {
        puzzleUpdated(to, from) {
            if (to) {
                this.setProgress();
                this.$store.dispatch("puzzles/setPuzzleUpdated", null);
            }
        },
    },
    methods: {
        getPuzzles() {
            this.$store
                .dispatch("puzzles/get", {
                    sort: this.sortArr[this.currentSort].key,
                    reverse: this.reverse,
                    hide_completed: this.hideComplete ? 1 : 0,
                })
                .then(() => {
                    this.pageLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                    this.setProgress();
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        updateMoreIndex() {
            this.moreIndex = this.puzzles.length - 2;
        },
        showMore() {
            if (this.next) {
                this.moreLoader = true;
                this.$store
                    .dispatch("puzzles/getNext")
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                        this.setProgress();
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        setProgress() {
            for (let j in this.puzzles) {
                let val = this.puzzles[j].completed;
                let base, progressValue;
                let count = 0;
                let checkEls = () => {
                    base = document.getElementById("base" + j);
                    progressValue = document.getElementById("progress-value" + j);
                    if ((!base || !progressValue) && count < 6) {
                        count++;
                        setTimeout(() => {
                            checkEls();
                        }, 50);
                    }

                    if (base && progressValue) {
                        progressValue.innerHTML = "";
                        if (val == 0) {
                            return;
                        }
                        const CIRCUMFERENCE = base.getTotalLength();
                        const UNIT = (CIRCUMFERENCE * val) / 10000;
                        let circles = [];

                        for (let i = 0; i < 100; i++) {
                            let pos = base.getPointAtLength(i * UNIT);
                            let o = {
                                cx: pos.x,
                                cy: pos.y,
                                r: 3,
                                "fill-opacity": 1,
                                fill: `hsl(${(i * (75 - 1)) / 100},100%,50%)`,
                            };
                            circles.push(this.drawCircle(o, progressValue));
                        }
                    }
                };
                checkEls();
            }
        },
        drawCircle(o, parent) {
            let circle = document.createElementNS(this.SVG_NS, "circle");
            for (var name in o) {
                if (o.hasOwnProperty(name)) {
                    circle.setAttributeNS(null, name, o[name]);
                }
            }
            parent.appendChild(circle);
            return circle;
        },
        sort(id) {
            this.showSort = false;
            if (this.currentSort == id) return;
            this.currentSort = id;
            this.getPuzzles();
        },
        clickOutsideContext() {
            this.showSort = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
@import "~@/assets/styles/pages/_puzzles";
</style>
